import React, { useState, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function Backdrops({ setbackdrop, backdrop }) {
  const [saves, setsaved] = useState(false);
  const history = useHistory();
  const { t } = useTranslation();
  useEffect(() => {
    setTimeout(function () {
      setsaved(true);
    }, 2000);
  }, [backdrop]);

  useEffect(() => {
    setTimeout(function () {
      setsaved(false);
      setbackdrop(false);
      history.push("/preview");
    }, 3000);
  }, [saves]);

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdrop}
      >
        {!saves ? (
          <CircularProgress style={{ color: "#000" }} size={100} />
        ) : (
          <div style={{ color: "#000" }}>
            <h2>{t("save")}!</h2>
          </div>
        )}
      </Backdrop>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={saves}
      ></Backdrop>
    </div>
  );
}
